import { render, staticRenderFns } from "./alergia.vue?vue&type=template&id=0dca7f3f"
import script from "./alergia.vue?vue&type=script&lang=js"
export * from "./alergia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports